import { Link } from 'react-router-dom';
import { useCryptoAgenda } from '@/hooks/queries';
import { SectionHead } from '@/components/ui';
import { CRYPTO_TAB_PATH } from '@/lib/receipts';
import { formatDate } from '@/lib/format';
import { formatCrypto, INSTALLMENT_STATUS_LABELS } from '@/lib/crypto';
import './crypto.css';

/** No painel: as parcelas em cripto a cobrar hoje e as atrasadas. Some quando não há nada. */
export function CryptoAgendaCard({ showMember }: { showMember: boolean }) {
  const { data } = useCryptoAgenda();
  if (!data || data.items.length === 0) return null;

  const summary = [
    data.today > 0 ? `${data.today} ${data.today === 1 ? 'vence hoje' : 'vencem hoje'}` : null,
    data.overdue > 0 ? `${data.overdue} ${data.overdue === 1 ? 'atrasada' : 'atrasadas'}` : null,
  ].filter(Boolean).join(' · ');

  return (
    <section className="card crypto-agenda" aria-labelledby="crypto-agenda-title">
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <SectionHead title={<span id="crypto-agenda-title">Parcelas em cripto para cobrar</span>} />
        </div>
        <span className={data.overdue > 0 ? 'chip chip-warning' : 'chip chip-primary'}>{summary}</span>
        <Link to={CRYPTO_TAB_PATH} className="btn btn-sm">Abrir os carnês</Link>
      </div>
      <ul className="crypto-agenda-list">
        {data.items.slice(0, 8).map((item) => (
          <li key={item.installment.id} className="crypto-agenda-row">
            <span className={item.installment.status === 'OVERDUE' ? 'chip chip-warning' : 'chip chip-primary'}>
              {item.installment.status === 'OVERDUE' ? `Venceu ${formatDate(item.installment.dueDate)}` : INSTALLMENT_STATUS_LABELS.TODAY}
            </span>
            <span className="truncate">
              <strong style={{ fontWeight: 500 }}>{item.description}</strong>
              <span className="muted">
                {' '}· parcela {item.installment.number}/{item.installmentsCount}
                {item.lead ? ` · ${item.lead.name}` : ''}
                {showMember ? ` · ${item.member.name}` : ''}
              </span>
            </span>
            <span className="num nowrap" style={{ fontWeight: 600 }}>{formatCrypto(item.installment.amount, item.currency)}</span>
          </li>
        ))}
      </ul>
      {data.items.length > 8 ? (
        <p className="muted" style={{ margin: '8px 0 0', fontSize: 12.5 }}>e mais {data.items.length - 8} na página de vendas em cripto.</p>
      ) : null}
    </section>
  );
}
